module.exports = __webpack_public_path__ + "assets/img/qr_code.0542926b.jpg";